/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';

export const SubLinkContainer = styled.div<{ customMarginLeft?: string; borderLeft?: boolean }>`
  margin-left: ${(props) => props.customMarginLeft || '16px'};
  display: flex;
  flex-direction: column;
  ${({ borderLeft, theme }) => (borderLeft ? `border-left: 1px solid ${theme.color.gray200};` : '')}
`;
